import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subject } from "rxjs";
import {
  defaultCountryCode,
  defaultCountryCodeId,
} from "src/app/global/constant";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-country-code-text-input",
  templateUrl: "./country-code-text-input.component.html",
  styleUrls: ["./country-code-text-input.component.scss"],
  standalone: false,
})
export class CountryCodeTextInputComponent {
  countrylist: any[] = [];
  countrycodeid: any = "";
  selectedCountry: any = null;
  @Input() countryCode: string = defaultCountryCode;
  @Input() placeholder: any;
  @Input() label: any;
  @Input() type = "text";
  @Input() min = "";
  @Input() max = "";
  @Input() readonly: boolean = false;
  @Input() isFormSubmitted: boolean = false;
  @Input() class: string = "";

  @Input()
  set control(control: FormControl) {
    this._control = control;
    this.onControlChange$.next();
  }
  get control(): FormControl {
    return this._control;
  }
  private _control: FormControl = new FormControl();

  private onControlChange$: Subject<void> = new Subject();
  @Output()
  valueChanges = new EventEmitter<any>();

  @Output()
  countrycodereturn = new EventEmitter<any>();
  constructor(private masterService: MasterService) {}
  ngOnInit(): void {
    this.masterService.getCountryCodeList().subscribe((res: any) => {
      if (res && res.statusCode == 200) {
        this.countrylist = res.data;
        if (this.countryCode) {
          this.countrycodeid = `${
            this.countrylist.find((a) => a.phone_code == this.countryCode)?.id
          }`;
        } else {
          this.countrycodeid = defaultCountryCodeId;
        }
        this.onCountryChange(this.countrycodeid, false);
      }
    });
  }

  onCountryChange(selectedValue: string, callEmitter: boolean): void {
    this.selectedCountry = this.countrylist.find((a) => a.id == selectedValue);
    // this.min = this.selectedCountry.max_digit;
    // this.max = this.selectedCountry.max_digit;
    this.min = "1";
    this.max = "100";
    this.countryCode = this.selectedCountry?.phone_code;
    if (callEmitter) {
      this.countrycodereturn.emit({ code: this.countryCode });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["isFormSubmitted"]) {
      this.isFormSubmitted = changes["isFormSubmitted"]?.currentValue;
    }

    if (changes["control"]) {
      this.control = changes["control"]?.currentValue;
    }

    if (changes["countryCode"]?.currentValue) {
      this.countryCode = changes["countryCode"]?.currentValue;
      this.countrycodeid = `${
        this.countrylist.find((a) => a.phone_code == this.countryCode)?.id
      }`;
      this.onCountryChange(this.countrycodeid, false);
    }
  }

  getPlaceholder(): string {
    if (
      (this.isFormSubmitted || this.control?.touched) &&
      this.control?.errors
    ) {
      if (this.control.errors["required"]) {
        return `Please enter ${this.label}`;
      }
      if (this.control.errors["minlength"]) {
        return `Min length: ${this.control.errors["minlength"].requiredLength}`;
      }
      if (this.control.errors["pattern"]) {
        return `Please enter a valid ${this.label}`;
      }
    }
    return this.placeholder; // default placeholder when no error
  }
}
